module.exports = __webpack_public_path__ + "assets/img/keogh.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/keogh.png
// module id = 1945
// module chunks = 0